import React, { useContext, useEffect, useRef, useState } from "react";
import { NotificacionExtendida } from "@components/general/Alertas/Alertas";
import { getNotificacionesUsuario, updateFechaUltimoAcceso, validateCredenciales } from "@helpers/httpRequests/httpRequestsUsuarios/httpRequestsUsuarios";
import UserContext from "@context/User/UserContext";
import dashboardRoutesPaths from "@helpers/dashboardRoutesPaths/dashboardRoutesPaths";
import getUnixTimestamp from "@helpers/dates/getUnixTimestamp/getUnixTimestamp";
import localStorageItemNames from "@helpers/localStorage/localStorageItemNames";
import typesTiposUsuario from "@helpers/types/typesTiposUsuario";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faSpinner } from "@fortawesome/free-solid-svg-icons";
import useCapsLockWatcher from "@customHooks/useCapsLockWatcher";
import CapsLockTooltip from "@components/general/CapsLockTooltip/CapsLockTooltip";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { FloatingLabel, Image } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import { useTranslation } from "react-i18next";
import { getCurrentLanguage } from "@helpers/idiomas/validation/getCurrentLanguage";

function getToken() { return localStorage.getItem('api_accessToken'); }
function setTokens(a, r) {
  localStorage.setItem('api_accessToken', a);
  localStorage.setItem('api_refreshToken', r);
}

async function apiFetch(base, path, opts = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(opts.headers ?? {}),
  };

  let res = await fetch(`${base}${path}`, { ...opts, headers });

  if (res.status === 401) {
    const rt = localStorage.getItem('api_refreshToken');
    if (!rt) return null;
    const rr = await fetch(`${base}/api/v1/auth/refresh`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refreshToken: rt }),
    });
    if (!rr.ok) {
      localStorage.removeItem('api_accessToken');
      localStorage.removeItem('api_refreshToken');
      return null;
    }
    const { accessToken, refreshToken: nrt } = await rr.json();
    setTokens(accessToken, nrt);
    res = await fetch(`${base}${path}`, {
      ...opts,
      headers: { ...headers, Authorization: `Bearer ${accessToken}` },
    });
  }

  return res;
}


async function syncUserWithAPI(frontendUser) {
  // frontendUser = { email, password, name }
  // Disponible en localStorage del frontend en el momento del login

  // 1. Intentar registro
  const res = await fetch('http://192.168.2.81:3000/api/v1/auth/register', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email: frontendUser.email,
      password: frontendUser.password,
      name: frontendUser.name,
    }),
  })

  if (res.ok) {
    const { accessToken, refreshToken, user } = await res.json()
    localStorage.setItem('api_accessToken', accessToken)
    localStorage.setItem('api_refreshToken', refreshToken)
    return user
  }

  if (res.status === 409) {
    // Ya existe → login directo
    const loginRes = await fetch('http://192.168.2.81:3000/api/v1/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: frontendUser.email,
        password: frontendUser.password,
      }),
    })
    const { accessToken, refreshToken, user } = await loginRes.json()
    localStorage.setItem('api_accessToken', accessToken)
    localStorage.setItem('api_refreshToken', refreshToken)
    return user
  }
}

// Llamar justo después del login del frontend
async function onFrontendLogin(frontendUser) {
  await syncUserWithAPI(frontendUser)
  // api_accessToken disponible para todos los calls posteriores
}

export const IniciarSesion = ({ mobileBtnRegistro }) => {

	const {t} = useTranslation('translation', { lng: localStorage.getItem('i18nextLng') ? localStorage.getItem('i18nextLng'): document.querySelector('html').lang});

	const history = useHistory();

	const inputContrasenia = useRef(null);

	const isCapsLockOn = useCapsLockWatcher(inputContrasenia);

	const [formValues, setFormValues] = useState({
		nombreUsuario: "",
		contrasenia: "",
		acceso: false,
	});

	const [showPassword, setShowPassword] = useState(false);

	const [showSpinner, setShowSpinner] = useState(false);

	const { nombreUsuario, contrasenia } = formValues;

	const { contextValue, setContextValue } = useContext(UserContext);

	/**
	 * Metodo encargado de validar credenciales y
	 * dar acceso al dashboard
	 * @param {*} e
	 */
	const handleCredentials = async (e) => {
		e.preventDefault();

		setShowSpinner(true);

		try {

			const { tipoUsuario, token, datosUsuario: arrayDatosUsuario } = await validateCredenciales({ nombreUsuario, contrasenia });

			const [datosUsuario] = arrayDatosUsuario;

			
			// await onFrontendLogin({
			// 	email: datosUsuario.correo,
			// 	password: datosUsuario.alias,
			// 	name: `${datosUsuario.nombreCompleto} ${datosUsuario.apellidos}`
			// })

			

			let pathRedirection = "";

			switch (tipoUsuario) {
				case typesTiposUsuario.estudiante:
					if (datosUsuario.segundoPerfilRegistrado) {
						pathRedirection = dashboardRoutesPaths.perfiles;
					} else {
						pathRedirection = dashboardRoutesPaths.dashboard;
					}
					break;

				case typesTiposUsuario.asesor:
				case typesTiposUsuario.empleado:
				case typesTiposUsuario.administrador:
				case typesTiposUsuario.vendedor:
				case typesTiposUsuario.capacitador:
				case typesTiposUsuario.invitado:
				case typesTiposUsuario.lecturaVeloz:
				case typesTiposUsuario.asesorLectura:
				case typesTiposUsuario.cobranza:
					pathRedirection = dashboardRoutesPaths.dashboard;

					break;

				default:
					pathRedirection = dashboardRoutesPaths.default;

					break;
			}

			if (!datosUsuario.intereses && tipoUsuario !== typesTiposUsuario.invitado && tipoUsuario !== typesTiposUsuario.lecturaVeloz && tipoUsuario !== typesTiposUsuario.asesorLectura) {
				pathRedirection = dashboardRoutesPaths.intereses;
			}

			// const ultimoAcceso = getUnixTimestamp();

			// try {
			// 	await updateFechaUltimoAcceso({
			// 		idPersona: datosUsuario.idPersona,
			// 		fecha: ultimoAcceso,
			// 	});
			// } catch (error) {
			// 	console.log(error);
			// }

			// fetch('https://api.ipify.org?format=json')
			// 	.then(response => response.json())
			// 	.then(data => {
			// 		const ip = data.ip;

			// 		fetch(`https://ipapi.co/${ip}/json/`)
			// 			.then(function (response) {
			// 				response.json().then(jsonData => {
			// 					console.log(jsonData);

			// 					setContextValue({
			// 						...contextValue,
			// 						usuarioLogeado: datosUsuario,
			// 						paisSesion: jsonData.country
			// 					});
			// 				});
			// 			})
			// 			.catch(function (error) {
			// 				console.log(error)
			// 			});
			// 	});

			setContextValue({
				...contextValue,
				usuarioLogeado: datosUsuario,
			});

			setShowSpinner(false);

			localStorage.setItem(localStorageItemNames.datosUsuario, JSON.stringify(datosUsuario));

			localStorage.setItem(localStorageItemNames.token, token);

			history.replace(pathRedirection);
		} catch (error) {
			console.log("error validando las credenciales: ", error);

			setShowSpinner(false);

			const { code, message } = error;

			if (code === 500) {
				let notificationMessage = "";

				switch (message) {
					case "wrong_password":
						notificationMessage = t("La contraseña es incorrecta, verifica que los datos sean correctos.");
						break;

					case "user_not_found":
						notificationMessage = t("Usuario no encontrado, verifica que los datos sean correctos");
						break;

					case "try_again":
						notificationMessage = t("Ocurrió un error inesperado, vuelve a intentar. Si el error continúa, ponte en contacto con Soporte Técnico");
						break;
					case "use_alias":
						notificationMessage = t("Algo sucedió al validar tu nombre de usuario, utiliza tu alias para iniciar sesión.\n Si el problema persiste contacta a Soporte.");
						break;
					default:
						break;
				}

				NotificacionExtendida("error", notificationMessage);
			}

			//Entra aqui cuando el estatus del usuario es 0
			if (code === 401) {
				const { data, message } = error;

				const { tipoUsuario, token, datosUsuario: arrayDatosUsuario } = data;

				const [datosUsuario] = arrayDatosUsuario;

				if (message === "Servicio ináctivo") {
					NotificationManager.warning(t("Servicio inactivo, renueva para disfrutar de todos los beneficios de tu plataforma Click+"));

					setContextValue({
						...contextValue,
						usuarioLogeado: datosUsuario,
					});

					setShowSpinner(false);

					localStorage.setItem(localStorageItemNames.datosUsuario, JSON.stringify(datosUsuario));

					localStorage.setItem(localStorageItemNames.token, token);

					history.replace(dashboardRoutesPaths.dashboard);
				}
			}
		}
	};

	/**
	 * metodo encargado de recopilar informacion de los input y
	 * guardarlos en la variables local de estado formValues
	 * @param {*} event
	 */
	const handleInputChange = (event) => {
		try {
			event.preventDefault();

			const { name, value } = event.target;

			setFormValues({
				...formValues,
				[name]: value.trim(),
			});
		} catch (error) {
			console.log(error);
		}
	};

	const handleShowPassword = () => {
		setShowPassword(!showPassword);
	};

	useEffect(() => {
	  const configurarLenguaje = () =>{
		const lang = document.querySelector('html').lang;


		localStorage.setItem('i18nextLng', lang);
	  };

	  configurarLenguaje();
	}, [])
	

	return (
		<Row className={`text-center justify-content-center align-items-center h-100`}>
			<Col className=" col-12 col-md-10 col-xl-8" style={{background: "#ffffff", borderRadius: "15px", paddingTop: '3rem', paddingBottom: '3rem'}}>
				{/* <Container fluid> */}
					<Row className="m-4">
						<Col>
							<Col className="text-center">
							<Image src={require("@assets/images/click.png")} style={{width: "250px"}} />
							<h4>{t('Log In')}</h4>

							</Col>

							<Form className="mt-4" onSubmit={handleCredentials} >

								<FloatingLabel label={t('Username')} className="mb-3">
									<Form.Control
										className="input-4 input-field"
										required
										type="text"
										placeholder={t('Username')}
										value={nombreUsuario}
										name="nombreUsuario"
										onChange={handleInputChange}
										autoComplete="off"
										style={{backgroundColor: "#e6e6e6ff"}}
									/>
								</FloatingLabel>

								<Form.Group as={Col} className="align mt-3">
									<InputGroup className="mt-3">
										<InputGroup.Text onClick={handleShowPassword} className="pointer">
											<FontAwesomeIcon icon={faEye} />
										</InputGroup.Text>

										<FloatingLabel label={t('Password')}>
											<Form.Control
												className="input-field"
												required
												name="contrasenia"
												value={contrasenia.trim()}
												type={showPassword ? "text" : "password"}
												placeholder={t('Password')}
												onChange={handleInputChange}
												autoComplete="off"
												ref={inputContrasenia}
												style={{backgroundColor: "#e6e6e6ff"}}
											/>
										</FloatingLabel>

										<CapsLockTooltip input={inputContrasenia} isCapsLockOn={isCapsLockOn} />
									</InputGroup>
								</Form.Group>

								<Form.Group as={Col} className="align mt-3">
									<div className="d-grid gap-2">
										<Button type="submit" className="btn-warning btn4" size="lg">
											Iniciar sesi&oacute;n {showSpinner && <FontAwesomeIcon icon={faSpinner} />}
										</Button>
									</div>
								</Form.Group>
							</Form>
						
						</Col>
					</Row>

					<Row className="text-center justify-content-center align-items-center mt-3">
						<a style={{ textDecoration: "none" }} href={dashboardRoutesPaths.recuperacionCredenciales}>
							<p className="p text-primary">Olvid&eacute; mi contraseña</p>
						</a>
					</Row>

					<Row className="text-center justify-content-center align-items-center">
						<a style={{ textDecoration: "none" }} href={dashboardRoutesPaths.recuperacionNombreUsuario}>
							<p className="p text-primary">Olvid&eacute; mi nombre usuario</p>
						</a>
					</Row>
				{/* </Container> */}
			</Col>
		</Row>
	);
};
